"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.groupForm.title': 'Dodaj grupę',
    'whatsapp.groupForm.back': 'Wróć',
    'whatsapp.groupForm.cancel': 'Anuluj',
    'whatsapp.groupForm.save': 'Zapisz',
    'whatsapp.groupForm.name': 'Nazwa grupy',
    'whatsapp.groupForm.namePlaceholder': 'Wprowadź nazwę grupy...',
    'whatsapp.groupForm.pinMessage': 'Przypięta wiadomość',
    'whatsapp.groupForm.pinMessagePlaceholder': 'Treść wiadomości do przypięcia w grupie...',
    'whatsapp.groupForm.pinMessageHint': 'Gdy śledzenie jest włączone, a bot jest administratorem, ta wiadomość zostanie przypięta.',
    'whatsapp.groupForm.nameRequired': 'Nazwa grupy jest wymagana.',
    'whatsapp.groupForm.avatar': 'Awatar',
    'whatsapp.groupForm.selectAvatar': '-- Wybierz awatara --',
    'whatsapp.groupForm.botInstruction': 'Instrukcja bota',
    'whatsapp.groupForm.botInstructionPlaceholder': 'Wprowadź instrukcje dla bota WhatsApp...',
    'whatsapp.groupForm.inviteMembers': 'Członkowie do zaproszenia',
    'whatsapp.groupForm.memberPlaceholder': 'Wprowadź numer telefonu lub @nazwę użytkownika...',
    'whatsapp.groupForm.addMember': 'Dodaj członka',
    'whatsapp.groupForm.noMembersYet': 'Nie dodano jeszcze żadnych członków.',
    'whatsapp.groupForm.createSuccess': 'Grupa została pomyślnie utworzona.',
    'whatsapp.groupForm.createFailed': 'Nie udało się utworzyć grupy.',
};
